import { useTranslation } from 'react-i18next';

import { Button, Menu } from '@cfa/react-core';
import {
  FileCertificate,
  Notes,
  Plus,
  SuccessOutline,
} from '@cfa/system-icons';

interface SectionButtonsProps {
  addProcedure?: (id?: string) => void;
  addQuiz: () => void;
  setShowAddTask: (task: boolean) => void;
  showAddTask: boolean;
}

const SectionButtons: React.FC<SectionButtonsProps> = ({
  setShowAddTask,
  addProcedure,
  showAddTask,
  addQuiz,
}) => {
  const { t } = useTranslation();

  const hideAddTaskIfAddingTask = () => {
    if (showAddTask) {
      setShowAddTask(false);
    }
  };

  return (
    <div className="mt-4 flex">
      <Menu.Root>
        <Button
          variant="outlined"
          size="sm"
          color="secondary"
          className="max-w-fit"
          data-testid="sectionAddButton"
        >
          <Plus size="xs" />
          {t('Generic.addContent')}
        </Button>

        <Menu.Popover>
          <Menu.Container className="[&>div]:text-secondary-base-alt!">
            <Menu.Item
              data-testid="sectionAddResourceButton"
              onAction={() => {
                hideAddTaskIfAddingTask();
                addProcedure?.();
              }}
            >
              <Notes />
              {t('Generic.resource')}
            </Menu.Item>
            <Menu.Item
              data-testid="sectionAddTaskButton"
              onAction={() => {
                setShowAddTask(true);
              }}
            >
              <SuccessOutline />
              {t('Generic.task')}
            </Menu.Item>
            <Menu.Item
              data-testid="sectionAddQuizButton"
              onAction={() => {
                hideAddTaskIfAddingTask();
                addQuiz();
              }}
            >
              <FileCertificate />
              {t('Generic.quiz')}
            </Menu.Item>
          </Menu.Container>
        </Menu.Popover>
      </Menu.Root>
    </div>
  );
};

export default SectionButtons;
